import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import classNames from 'classnames';
import { Card, Row, Col, Modal, Button, Form, FormLabel, ListGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaFileExport, FaMapMarkerAlt } from "react-icons/fa";
import iconoPng from '../../../../../assets/img/icons/export.png';
import AdvanceTableFooter from "../../../../../components/common/advance-table/AdvanceTableFooter";
import useAdvanceTable from "../../../../../hooks/useAdvanceTable";
import { useAdvanceTableContext } from "../../../../../providers/AdvanceTableSearchProvider";
import AdvanceTableProvider from "../../../../../providers/AdvanceTableSearchProvider";
import AdvanceTableCustom from '../../../../../components/common/advance-table/AdvanceTableCustom';
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
//import GoogleMapComponent from "../../../../../components/common/GoogleMap";
import { GoogleMapsProvider } from "../../../../../providers/GoogleMapsProvider";
import "dayjs/locale/es";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from 'xlsx'
import GoogleMapSelector, { obtenerInfoView, obtenerInfoViewTop } from "../../../../../components/common/google-maps-selector/GoogleMapSelector";
import { obtenerIconoAlerta, obtenerIconoEvento, obtenerImgAlerta, obtenerImgAlertaCamara, obtenerImgAlertaOmisiones } from '../../../../../components/common/google-maps-selector/IconosTabla';
import Flex from '../../../../../components/common/Flex';

// Activamos el soporte para formatos personalizados
dayjs.extend(customParseFormat)
dayjs.locale("es")

const rowsPerPageOptions = [100, 200, 300];

const formatFecha = (fechaStr) => {
    if (!fechaStr || typeof fechaStr !== "string") return "N/A";
    try {
        return dayjs(fechaStr, "YYYY/MM/DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
    } catch (error) {
        console.error("Error al formatear la fecha:", error);
        return "N/A";
    }
};

const RecorridosTableList = ({ data = [], perPage = 100, title, isGroup, geocercas, referencias, clientes }) => {
    const [showMarcadorModal, setShowMarcadorModal] = useState(false);
    const [contentMarcadorModal, setContentMarcadorModal] = useState([]);
    const [geofilter, setGeofilter] = useState([]);
    const [infoView, setInfoView] = useState(null);
    const [globalFilter, setGlobalFilter] = useState('');
    const [inputValue, setInputValue] = useState('');
    const debounceTimeout = useRef(null);
    // 🔹 Se asegura un valor predeterminado para evitar errores
    const safeTableData = Array.isArray(data) ? data : [];
    console.log("RecorridosTableList");
    console.log(safeTableData);
    // Estado para manejar el modal del mapa
    const [showMapModal, setShowMapModal] = useState(false);

    const [selectedLocation, setSelectedLocation] = useState({
        lat: null,
        lng: null,
    });


    const pagination = {
        pageIndex: 0, //initial page index
        pageSize: perPage, //default page size
    }

    const obtenerIcono = (tipoAlerta) => {
        var icono = obtenerIconoEvento(tipoAlerta);
        const src = icono?.props?.src;
        return icono;
    };

    const obtenerMarcadorAlertas = (alerta, isMarkerColumn = false) => {
        var index = 0;

        //if (alerta.alerta_real?.includes("Movimiento")) return null;
        index += 1;
        let tipo_alerta = (alerta.alerta_real.toLowerCase() === 'apagado' && alerta.tipo_real === 1 ? 0 : alerta.tipo_real);

        //let arregloFecha = (alerta.fecha || '').split(' ');
        if (isMarkerColumn === false) {
            setInfoView(obtenerInfoViewTop({
                markerId: index,
                titulo: (alerta.no_economico + " / " + alerta.alias) || '',
                colorFondoTitulo: alerta.color || 'black',
                colorTextoTitulo: 'text-white',
                velocidad: alerta.velocidad || '',
                alerta: alerta.alerta_real || '',
                fecha: dayjs(alerta.fecha).format('DD/MM/YYYY HH:mm:ss') || '',
                ruta: alerta.distancia ? (alerta.distancia).toFixed(3) : 'N/A',
                chofer: alerta.chofer?.nombreChofer ? alerta.chofer?.nombreChofer.length > 0 ? alerta.chofer?.nombreChofer : 'N/A' : 'N/A'
            }))
        }
        return isMarkerColumn === false ? {
            lat: parseFloat(alerta.latitud),
            lng: parseFloat(alerta.longitud),
            icon: obtenerIcono(alerta.tipo_real, alerta.tipo_alerta),
            radio: alerta.radio,
            title: alerta.alerta_real
            /*infoView: obtenerInfoView({
              markerId: index,
              titulo: (alerta.no_economico + " / " + alerta.alias) || '',
              colorFondoTitulo: alerta.color || 'black',
              colorTextoTitulo: 'text-white',
              velocidad: alerta.velocidad || '',
              alerta: alerta.alerta_real || '',
              fecha: arregloFecha.length > 0 ? arregloFecha[0] : '',
              hora: arregloFecha.length > 0 ? arregloFecha[1] : '',
              ruta: (alerta.distancia ? alerta.distancia.toFixed(3) : 'N/A'),
              chofer: alerta.chofer?.nombreChofer ? alerta.chofer?.nombreChofer.length > 0 ? alerta.chofer?.nombreChofer : 'N/A' : 'N/A'
            }),*/
        } :
            {
                lat: parseFloat(alerta.latitud),
                lng: parseFloat(alerta.longitud),
                icon: obtenerIcono(alerta.tipo_real, alerta.tipo_alerta),
                radio: alerta.radio,
                /*infoView: obtenerInfoView({
                  markerId: index,
                  titulo: alerta.alerta_real || '',
                  colorFondoTitulo: '#5f07a3',
                  colorTextoTitulo: 'text-white',
                  ocultarBody: true
                }),*/
            };
    };

    // Función para abrir el modal con la latitud y longitud seleccionadas
    const handleShowMap = (rowData) => {

        //console.log(geocercas);
        setGeofilter(null);
        let markers = [];
        if (rowData && Array.isArray(geocercas)) {
            /*CARGA DE GEOCERCAS*/
            // Extrae los nombres de las geocercas asignadas al evento
            const nombresAsignadas = (rowData.geocercas?.geocercasasignadas || [])
                .map(g => g.nombreGeocerca?.trim().toLowerCase());
            // Filtra solo las geocercas base que coincidan por nombre
            const geocercasFiltradas = geocercas.filter(g =>
                nombresAsignadas.includes(g.nombre?.trim().toLowerCase())
            );
            // Asigna las geocercas que sí coincidieron
            setGeofilter(geocercasFiltradas);

            const arregloGeocercas = geocercasFiltradas.map(g => {
                const sumaTotales = g.puntos.reduce(
                    (acc, punto) => {
                        acc.lat += punto.latitud;
                        acc.lng += punto.longitud;
                        return acc;
                    },
                    { lat: 0, lng: 0 }
                );
                const total = g.puntos.length;
                return ({
                    ...g,
                    lat: sumaTotales.lat / total,
                    lng: sumaTotales.lng / total
                })
            });
            /*CARGA DE CLIENTES*/
            const nombreClientes = (rowData.clientes_concat || '').toLowerCase().split(',');
            const clientesFiltrados = (clientes.filter(g => nombreClientes.includes(g.nombre.toLowerCase())));
            /*CARGA DE REFERENCIAS*/
            const nombreReferencias = (rowData.referencias_concat || '').toLowerCase().split(',');
            const referenciasFiltradas = (referencias.filter(g => nombreReferencias.includes(g.nombre.toLowerCase())));

            markers = [
                ...((clientesFiltrados || []).map(c => {
                    let alerta = {
                        latitud: c?.latitud,
                        longitud: c?.longitud,
                        tipo_real: 99990,
                        alerta_real: c.nombre,
                        radio: c?.radio || 0,
                    };
                    return obtenerMarcadorAlertas(alerta, true);
                }) || []),
                ...((arregloGeocercas || []).map(c => {

                    let alerta = {
                        latitud: c.lat,
                        longitud: c.lng,
                        tipo_real: 99991,
                        alerta_real: c.nombre
                    };
                    return obtenerMarcadorAlertas(alerta, true);
                }) || []),
                ...((referenciasFiltradas || []).map(c => {
                    let alerta = {
                        latitud: c?.latitud,
                        longitud: c?.longitud,
                        tipo_real: 99992,
                        alerta_real: c.nombre,
                        radio: c?.radio || 0,
                    };
                    return obtenerMarcadorAlertas(alerta, true);
                }) || [])
            ];
        }
        let evento = obtenerMarcadorAlertas({ ...rowData, alerta_real: rowData.nombreEvento, tipo_real: (rowData.nombreEvento.toLowerCase() === 'apagado' ? 0 : rowData.tipo) });
        console.log(markers);
        setSelectedLocation([evento, ...markers]);
        setShowMapModal(true);
    };

    const titulo = [{ A: 'Reporte de Recorridos' }, {}]

    const longitudes = []

    const creandoArchivo = (dataFinal) => {
        if (window['guardarBitacoraExport']) {
            try {
                window['guardarBitacoraExport']();
            } catch (error) {

            }
        }
        const libro = XLSX.utils.book_new();

        const hoja = XLSX.utils.json_to_sheet(dataFinal, { skipHeader: true });

        const _totalFilas = dataFinal.length + 1

        hoja["!merges"] = [
            XLSX.utils.decode_range("A1:E1"),
            XLSX.utils.decode_range("A2:E2"),
            //XLSX.utils.decode_range(`A${_totalFilas}:E${_totalFilas}`),
        ];

        let propiedades = [];

        longitudes.forEach((col) => {
            propiedades.push({
                width: col,
            });
        });

        hoja["!cols"] = propiedades;

        XLSX.utils.book_append_sheet(libro, hoja, "Recorridos");

        XLSX.writeFile(libro, "ReporteDeRecorridos.xlsx");
    };

    const exportarDatos = () => {

        let tabla = [
            {
                A: 'Fecha',
                B: 'Evento',
                C: 'Distancia (Km)',
                D: 'Marcador',
                E: 'Dirección'
            }
        ]

        safeTableData.forEach((i) => {

            tabla.push({
                A: formatFecha(i.fecha),
                B: i.nombreEvento || "N/A",
                C: i.distancia.toFixed(2) || "0",
                D: i.geocercas_concat?.trim() ||
                    i.clientes_concat?.trim() ||
                    i.referencias_concat?.trim() ||
                    "N/A",
                E: i.direccion
            })
        })

        const dataFinal = [...titulo, ...tabla]

        setTimeout(() => {
            creandoArchivo(dataFinal);
            //setLoading(false);
        }, 1000);
    }

    const handleExportar = () => {

        exportarDatos()
    }

    const handleShowMarcadorModal = useCallback((data) => {
        setShowMarcadorModal(true);
        setContentMarcadorModal(data);
    }, []);

    const TabTitle = ({ amount, percentage, type, updown, action }) => (
        <div className="d-flex flex-column align-items-start">
            <div className="d-flex align-items-center justify-content-start">
                <h6 className="mb-0 me-2 ">{amount}</h6>

                <FontAwesomeIcon
                    icon={(updown === undefined ? percentage : updown >= 0) ? 'caret-up' : 'caret-down'}
                    className={classNames('me-1', {
                        'text-success': type === 'up',
                        'text-danger': type === 'down',
                        'text-primary': type === 'standard',
                        'text-warning': type === 'warning',
                        'text-info': type === 'pending'
                    })}
                />


                <a
                    className={classNames({
                        'text-success': type === 'up',
                        'text-danger': type === 'down',
                        'text-primary': type === 'standard',
                        'text-warning': type === 'warning',
                        'text-info': type === 'pending'
                    })}
                    href="#!"
                    onClick={action}
                >
                    {percentage}
                </a>

            </div>


        </div>
    );

    const style = {
        display: "-webkit-box",
        WebkitLineClamp: 1, // Limita a 2 líneas
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    // 📌 Estructura de columnas basada en el objeto `alert` de la API
    const columns = [
        {
            accessorKey: "fecha", // 📌 Latitud
            header: "Fecha",
            cell: ({ row: { original } }) => (
                formatFecha(original.fecha)
            ),
            meta: {
                headerProps: {
                    className: "text-start",
                    style: { width: "13%" },
                },
                cellProps: {
                    className: "text-start",
                    style: {
                        width: "13%",
                        minWidth: "100px", // Añade un ancho mínimo absoluto
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                    }
                },
            },
        },
        {
            accessorKey: "nombreEvento", // 📌 Geocerca
            header: "Evento",
            cell: ({ row: { original } }) => original.nombreEvento || "N/A",
            meta: {
                headerProps: {
                    className: "text-start",
                    style: { width: "13%" },
                },
                cellProps: {
                    className: "text-start",
                    style: { width: "13%" },
                },
            },
        },
        /*  {
           accessorKey: "distancia", // 📌 Geocerca
           header: "Distancia(Km)",
           cell: ({ row: { original } }) => original.distancia.toFixed(2) || "0",
           meta: { headerProps: { className: "" } },
         }, */
        {
            accessorKey: "velocidad", // 📌 Geocerca
            header: "Velocidad(Km/h)",
            cell: ({ row: { original } }) => {
                let velocidad = (original.nombreEvento || "N/A").toLowerCase().includes('apagado') ? '0 Km/h' : (original.velocidad || "0") + ' Km/h';
                return velocidad;
            },
            meta: {
                headerProps: {
                    className: "text-start",
                    style: { width: "13%" },
                },
                cellProps: {
                    className: "text-start",
                    style: { width: "13%" },
                },
            },
        },
        {
            accessorKey: "marcador", // 📌 Geocerca
            header: "Marcador",
            cell: ({ row: { original } }) =>
                getLabelMarcador(original, handleShowMarcadorModal),

            /*   cell: ({ row: { original } }) => {
                const marcador =
                  original.geocercas_concat?.trim() ||
                  original.clientes_concat?.trim() ||
                  original.referencias_concat?.trim() ||
                  "N/A";
        
                return marcador;
              }, */
            meta: {
                headerProps: {
                    className: "text-start",
                    style: { width: "17%" },
                },
                cellProps: {
                    className: "text-start",
                    style: { width: "17%" },
                },
            },
        },
        /*  {
           accessorKey: "combustibleActual", // 📌 Geocerca
           header: "Combustible(L)",
           cell: ({ row: { original } }) =>
             original.vehiculos.capacidadtanque0litros || "0",
           meta: { headerProps: { className: "" } },
         }, */
        {
            accessorKey: "direccion", // 📌 Geocerca, Cliente, Referencia
            header: "Dirección",
            cell: ({ row: { original } }) => {

                const direccion = original.direccion || '';
                const texto = direccion.length > 25 ? `${direccion.slice(0, 25)}...` : direccion;
                return (
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-${original.id || Math.random()}`}>{direccion}</Tooltip>}
                    >
                        <span>{texto}</span>
                    </OverlayTrigger>
                );
                //return <span title={original.direccion}>{texto}</span>
            },
            meta: {
                headerProps: {
                    className: "text-start",
                    style: { width: "20%" },
                },
                cellProps: {
                    className: "text-start",
                    style: { width: "20%" },
                },
            },
        },
        {
            accessorKey: "temperatura",
            header: "Temperatura (°C)",
            cell: ({ row: { original } }) => original.temperatura != null ? `${original.temperatura} °C` : "N/A",
            meta: {
                headerProps: {
                    className: "text-start",
                    style: { width: "12%" },
                },
                cellProps: {
                    className: "text-start",
                    style: { width: "12%" },
                },
            },
        },
        {
            accessorKey: "mapa", // 📌 Mapa (icono)
            header: "Ubicacion",
            cell: ({ row: { original } }) => (
                <a
                    size="sm"
                    className="p-1"
                    href='#!'
                    onClick={() => {

                        handleShowMap(original)
                    }}
                >
                    <FaMapMarkerAlt className="text-danger" />
                </a>
                /*  <Button
                   variant="default"
                   size="sm"
                   className="btn-light rounded-5 p-1"
                   onClick={() => handleShowMap(original.latitud, original.longitud)}
                 >
                   <FaMapMarkerAlt className="text-danger" />
                 </Button> */
            ),
            meta: {
                headerProps: { className: "text-start" },
                cellProps: { className: "text-start" },
            },
        },
    ];

    const getLabelMarcador = (rowData, handleShowMarcadorModal) => {
        const paramsEntry = {
            Clientes: rowData.clientes_concat,
            Geocercas: rowData.geocercas_concat,
            Referencias: rowData.referencias_concat,
        };

        //Obtener propiedades con valor no vacío
        const propiedadesConValor = Object.entries(paramsEntry).filter(
            ([_, valor]) => valor.trim() !== ""
        );

        //Almacena los parametros para mostrarlos en el modal
        const contentModal = propiedadesConValor.map((item, index) => {
            return (
                {
                    key: item[0],
                    value: item[1]
                }
            )
        });

        //Cantidad datos con valor
        const cantidad = Object.values(paramsEntry)
            .flatMap(str => str.split(','))
            .filter(item => item.trim() !== '') // elimina vacíos y espacios
            .length;
        return (
            <div>
                {cantidad === 1 ? (

                    <div>
                        <strong style={style} title={`${propiedadesConValor[0][1]}`}>{propiedadesConValor[0][1]}</strong>
                        <span>{propiedadesConValor[0][0]}</span>
                    </div>

                    // <p>{propiedadesConValor[0][1]}</p>
                ) : cantidad == 0 ? (<span className="text-muted">N/A</span>) : (
                    <Col>
                        <Row >

                            <TabTitle
                                amount={`${cantidad}`}
                                percentage={'Ver'}
                                updown={1}
                                type='pending'
                                action={() => {
                                    handleShowMarcadorModal(contentModal)
                                }}
                            />
                        </Row>
                        <Row >
                            <span>Marcadores </span>
                        </Row>

                    </Col>
                )}
            </div>
        );
    };

    const normalize = (val) => {
        return (val ?? "").toString().trim().toLowerCase();
    };

    const filterItemAndChildren = (item, filter) => {
        let filteredChildren = [];
        if (Array.isArray(item.children)) {
            filteredChildren = item.children
                .map(child => filterItemAndChildren(child, filter))
                .filter(Boolean);
        }

        // Lógica de filtrado normalizado
        const normalizeText = (val, fallback = "N/A") => normalize(val || fallback);

        const velocidadText = (item.nombreEvento || "N/A").toLowerCase().includes('apagado')
            ? '0 Km/h'
            : `${item.velocidad || "0"} Km/h`;

        const fechaText = formatFecha(item.fecha);

        const marcadorText = [
            item.geocercas_concat,
            item.clientes_concat,
            item.referencias_concat
        ].filter(Boolean).join(', ');

        const marcadorNormalizado = marcadorText.trim() === '' ? 'n/a' : marcadorText;

        const direccionText = item.direccion?.trim() || 'N/A';
        const eventoText = item.nombreEvento?.trim() || 'N/A';
        const temperaturaText = item.temperatura != null ? `${item.temperatura} °C` : 'N/A';

        const matches = (
            normalize(fechaText).includes(filter) ||
            normalize(eventoText).includes(filter) ||
            normalize(velocidadText).includes(filter) ||
            normalize(marcadorNormalizado).includes(filter) ||
            normalize(direccionText).includes(filter) ||
            normalize(temperaturaText).includes(filter)
        );

        if (matches) {
            return {
                ...item,
                children: Array.isArray(item.children) ? item.children : []
            };
        }

        if (filteredChildren.length > 0) {
            return {
                ...item,
                children: filteredChildren
            };
        }

        return null;
    };



    const filteredData = useMemo(() => {
        if (!globalFilter || globalFilter.trim() === '') return safeTableData;

        const filter = globalFilter.trim().toLowerCase();

        return safeTableData
            .map(item => filterItemAndChildren(item, filter))
            .filter(Boolean);
    }, [safeTableData, globalFilter]);

    const table = useAdvanceTable({
        data: filteredData,
        columns,
        sortable: false,
        pagination,
        perPage,
    });


    /*   const table = useAdvanceTable({
        data: safeTableData, // 🔹 Ahora usa `safeTableData` para evitar errores
        columns,
        sortable: false,
        pagination,
        perPage,
      }); */



    const prepareTableForPrint = useCallback(() => {
        console.log('🚗 Preparando RecorridosTableList para impresión...');

        return new Promise((resolve) => {
            try {
                if (pagination && pagination.pageSize) {
                    // Guardar configuración original
                    const originalPageSize = pagination.pageSize;
                    const originalPageIndex = pagination.pageIndex || 0;

                    console.log(`📊 Config original: pageSize=${originalPageSize}, pageIndex=${originalPageIndex}`);

                    // ✅ IMPORTANTE: Usar setPageSize del hook de tabla
                    const newPageSize = Math.max(safeTableData.length, 1000);
                    console.log(`🔧 Estableciendo nuevo pageSize: ${newPageSize}`);

                    // ✅ USAR LA API DEL HOOK DE TABLA
                    table.setPageSize(newPageSize);
                    table.setPageIndex(0);

                    // Guardar configuración para restaurar después
                    window._originalRecorridosTableConfig = {
                        pageSize: originalPageSize,
                        pageIndex: originalPageIndex
                    };

                    // ✅ ESPERAR MÁS TIEMPO PARA RE-RENDER
                    setTimeout(() => {
                        console.log(`✅ RecorridosTableList preparada: ${safeTableData.length} filas totales`);
                        console.log(`📋 Página actual: ${table.getState().pagination.pageIndex}`);
                        console.log(`📋 Tamaño página: ${table.getState().pagination.pageSize}`);
                        console.log(`📋 Total páginas: ${table.getPageCount()}`);

                        resolve();
                    }, 2000); // ✅ AUMENTAR TIEMPO DE ESPERA
                } else {
                    console.log('✅ RecorridosTableList sin paginación, preparada inmediatamente');
                    resolve();
                }
            } catch (error) {
                console.error('❌ Error preparando RecorridosTableList:', error);
                resolve();
            }
        });
    }, [table, safeTableData.length]); // ✅ AGREGAR table A LAS DEPENDENCIAS

    const restoreTableAfterPrint = useCallback(() => {
        console.log('🔄 Restaurando RecorridosTableList después de impresión...');

        try {
            if (window._originalRecorridosTableConfig) {
                const originalConfig = window._originalRecorridosTableConfig;

                console.log(`🔄 Restaurando config: pageSize=${originalConfig.pageSize}, pageIndex=${originalConfig.pageIndex}`);

                // ✅ USAR LA API DEL HOOK DE TABLA PARA RESTAURAR
                table.setPageSize(originalConfig.pageSize);
                table.setPageIndex(originalConfig.pageIndex);

                // Limpiar configuración temporal
                delete window._originalRecorridosTableConfig;

                console.log('✅ Configuración de RecorridosTableList restaurada');
            }
        } catch (error) {
            console.error('❌ Error restaurando RecorridosTableList:', error);
        }
    }, [table]); // ✅ AGREGAR table A LAS DEPENDENCIAS

    // ✅ EXPONER FUNCIONES GLOBALMENTE
    useEffect(() => {


        return () => {
            if (window.prepareRecorridosTableForPrint) {
                delete window.prepareRecorridosTableForPrint;
            }
            if (window.restoreRecorridosTableAfterPrint) {
                delete window.restoreRecorridosTableAfterPrint;
            }
        };
    }, [prepareTableForPrint, restoreTableAfterPrint, title]);


    return (
        <>
            <AdvanceTableProvider {...table} >
                <Card className="h-100">
                    <Card.Header>
                        <Row className="d-flex align-items-center justify-content-between">
                            <Col md={6}>
                                <h6 className="mb-0 text-nowrap py-2 py-xl-2">{title}</h6>
                            </Col>
                            <Col md={4} className="d-flex justify-content-end align-items-center">

                                <Button
                                    variant="primary"
                                    size="sm"
                                    className="me-2 p-2"
                                    onClick={handleExportar}
                                >
                                    <img
                                        src={iconoPng}
                                        alt="Exportar" title='Exportar a Excel'
                                        style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} // Ajusta el tamaño
                                        className="me-1 ms-1"
                                    />

                                </Button>

                                <Form.Control
                                    type="search"
                                    placeholder="Buscar..."
                                    value={inputValue}
                                    onChange={e => {
                                        const value = e.target.value;
                                        setInputValue(value);
                                        if (debounceTimeout.current) {
                                            clearTimeout(debounceTimeout.current);
                                        }
                                        debounceTimeout.current = setTimeout(() => {
                                            setGlobalFilter(value || '');
                                            table.setPageIndex(0);
                                        }, 400);
                                    }}
                                    style={{ maxWidth: '200px' }}
                                    className="p-2"
                                />

                            </Col>

                            <Col md={2}>
                                <Form className="d-flex p-2 justify-content-end">


                                    <Form.Select
                                        className='p-2'
                                        size="sm"
                                        style={{ width: '100px' }}
                                        defaultValue={100}
                                        onChange={e => table.setPageSize(Number(e.target.value))}
                                    >
                                        {rowsPerPageOptions.map(value => (
                                            <option value={value} key={value}>
                                                {value}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form>
                            </Col>
                        </Row>
                        {/* <div className="border-bottom border-200 my-3"></div> */}
                    </Card.Header>
                    <Card.Body className="p-0">
                        <AdvanceTableCustom
                        />
                        {/**
             * <AdvanceTable
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{ className: "fs-10 mb-0 overflow-hidden" }}
            />
             */}
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection rowsPerPageOptions={[100, 200, 300]} />
                    </Card.Footer>
                </Card>
            </AdvanceTableProvider>
            {/* 🔹 Modal para ver el mapa */}
            <Modal
                show={showMapModal}
                onHide={() => setShowMapModal(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Evento: {(selectedLocation.length > 0 ? selectedLocation[0].title : '') || ''}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {infoView}
                    {selectedLocation.length > 0 ? (
                        <GoogleMapSelector
                            initialCenter={selectedLocation[0]}
                            markers={selectedLocation}
                            geocercas={geofilter}
                            zoomDefault={13}
                            mapStyle="Default"
                            className="vh-50"
                            showStreetView={false}
                        />
                    ) : (
                        <p>Ubicación no disponible</p>
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={showMarcadorModal} onHide={() => setShowMarcadorModal(false)} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <h6> Marcadores </h6>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="mb-3 d-flex justify-content-center">
                        <Col md={12}>
                            <ListGroup>
                                {contentMarcadorModal && contentMarcadorModal.map((item, index) => (
                                    <ListGroup.Item>
                                        <div>
                                            <span>{item.key.toUpperCase()}</span>
                                            <br />
                                            <strong>{item.value}</strong>
                                        </div>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>


        </>
    );
};

RecorridosTableList.propTypes = {
    tableData: PropTypes.arrayOf(
        PropTypes.shape({
            no_economico: PropTypes.string.isRequired,
            alerta_real: PropTypes.string.isRequired,
            fecha: PropTypes.string.isRequired,
            latitud: PropTypes.string,
            longitud: PropTypes.string,
            geocerca: PropTypes.string,
            chofer: PropTypes.string,
        })
    ),
    perPage: PropTypes.number,
};

export default RecorridosTableList;
